import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_SWITCH_LABEL_POSITION = {
  Left: "left",
  Right: "right",
} as const;

export type DSSwitchLabelPosition = ObjectValues<typeof DS_SWITCH_LABEL_POSITION>;
